import { useSelector } from 'react-redux';
import { selectTotalCount } from '../../selectors/totalCount';
import { selectSelectedFolder } from '../../selectors/folders';
import { selectSelectedEntitiesCount } from '../../selectors/selected';
import { getTextCount } from '../../utils/favoriteEntity';

interface ITopBarCount {
  count: number;
  text: string;
}

export const useTopBarCount = (): ITopBarCount => {
  const total = useSelector(selectTotalCount);
  const selectedFolder = useSelector(selectSelectedFolder);
  const selectedCount = useSelector(selectSelectedEntitiesCount);

  if (selectedCount) {
    return {
      count: selectedCount,
      text: `Выбрано ${selectedCount}`,
    };
  }

  let count = total || 0;
  if (selectedFolder) {
    count = selectedFolder.offersCount;
  }

  return {
    count: count || 0,
    text: getTextCount(count),
  };
};
